<template>
    <div class="ngdialog-content">
        <dialog-header>
            <h4>{{ $t('systems.replace_webserver') }}</h4>
        </dialog-header>

        <form name="changeRCForm" novalidate @submit.prevent="submit()" class="form">
            <div class="ngdialog__body">
                <div class="row form__row">
                    <div class="column-mobile-24">
                        <label for="serial_number" class="form__label">
                            {{ $t('systems.serial_number_new_rc') }}
                        </label>
                        <input
                            type="text"
                            class="form__field"
                            name="serial_number"
                            v-model="$v.formData.serial_number.$model"
                            required
                            v-autofocus
                            :class="{
                                'is-invalid': $v.formData.serial_number.$invalid || notFound,
                                'is-dirty': $v.formData.serial_number.$dirty,
                            }"
                            @input="notFound = false"
                        />

                        <div v-if="$v.formData.serial_number.$anyError || notFound">
                            <p class="form__error" v-if="!$v.formData.serial_number.required">
                                {{ $t('fields.serial_number_e_required') }}
                            </p>

                            <p class="form__error" v-if="notFound">
                                {{ $t('systems.no_rc_found_with_serial_number') }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="row form__row">
                    <div class="column-mobile-24">
                        <label for="verification_number" class="form__label">
                            {{ $t('fields.verification_number') }}
                        </label>
                        <input
                            type="text"
                            class="form__field"
                            name="verification_number"
                            v-model="$v.formData.verification_number.$model"
                            required
                            :class="{
                                'is-invalid': $v.formData.verification_number.$invalid,
                                'is-dirty': $v.formData.verification_number.$dirty,
                            }"
                        />

                        <div v-if="$v.formData.verification_number.$anyError">
                            <p class="form__error" v-if="!$v.formData.verification_number.required">
                                {{ $t('fields.verification_number_e_required') }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <dialog-buttons :submit-text="$t('systems.replace_rc_now')" :disabled="loading" />
        </form>
    </div>
</template>

<script>
import * as api from '@/api';
import { required } from 'vuelidate/lib/validators';
import DialogHeader from '@/components/DialogHeader';
import DialogButtons from '@/components/DialogButtons';
import autofocus from '@/directives/autofocus';

export default {
    name: 'system-change-webserver',
    components: {
        DialogHeader,
        DialogButtons,
    },
    directives: {
        autofocus,
    },
    props: {
        system: {
            type: Object,
            required: true,
        },
        successCallback: {
            type: Function,
        },
    },
    data() {
        let data = {
            formData: {
                serial_number: '',
                verification_number: '',
            },
            notFound: false,
            loading: false,
        };

        return data;
    },
    validations() {
        return {
            formData: {
                serial_number: {
                    required,
                },
                verification_number: {
                    required,
                },
            },
        };
    },
    methods: {
        submit() {
            this.notFound = false;

            if (this.$v.formData.$invalid) {
                this.$v.formData.$touch();
                return;
            }

            this.loading = true;

            api.systems
                .updateRC({ id: this.system.id, data: this.formData })
                .then(
                    () => {
                        if (this.successCallback) {
                            this.successCallback();
                        }

                        this.$emit('close');
                    },
                    () => {
                        this.notFound = true;
                    }
                )
                .catch()
                .then(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
